module.exports = __webpack_public_path__ + "img/contact.538e5688.jpg";